// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"i2nZ_MYUpE6g2gF93g8A"};